import {
  ADD_TO_CART,
  ADD_COMBO_TO_CART,
  REMOVE_PRODUCT_FROM_CART,
  INCREMENT_PRODUCT,
  DECREMENT_PRODUCT,
  VALIDATE_CART_REQUEST,
  VALIDATE_CART_SUCCESS,
  VALIDATE_CART_FAILURE,
  CHANGE_TIP_PERCENTAGE,
  CHANGE_SPECIAL_INSTRUCTIONS,
  PLACE_ORDER_REQUEST,
  PLACE_ORDER_SUCCESS,
  PLACE_ORDER_FAILURE,
  INVALIDATE_CART,
  TOGGLE_PRODUCT_IS_FAVOURITED,
  UNFAVOURITE_BY_FAVOURITE_ID,
  SET_IS_FOR_PREVIEW,
  RESET_INVALID_TIP_FLAG,
  INITIALIZE_VALIDATE_CART_WITH_NULL,
  EMPTY_CART,
  REMOVE_COMBO_FROM_CART,
  UPDATE_CART_PRODUCTS,
  UPDATE_CART_SCREEN,
  UPDATE_CART_REQUEST, //GLOBAL CART
  SET_CHECKOUT_AS_GUEST_BUTTON_IS_VISIBLE,
  SET_SHOW_GUEST_PERSONAL_DETAILS_PAGE,
  SET_ACCOUNT_FOUND_MODAL_IS_VISIBLE,
  SET_GUEST_PERSONAL_DETAILS,
  VALIDATE_GUEST_CART_REQUEST,
  VALIDATE_GUEST_CART_SUCCESS,
  VALIDATE_GUEST_CART_FAILURE,
  RESET_GUEST_PERSONAL_DETAILS,
  PLACE_GUEST_ORDER_REQUEST,
  PLACE_GUEST_ORDER_SUCCESS,
  PLACE_GUEST_ORDER_FAILURE,
  RESET_TIP_PERCENTAGE,
  SET_UPSELL_COMBOS,
  SET_PRODUCTS_TO_REPLACE_WITH_COMBO,
  SET_RELOAD_GIFT_CARD_DIALOG_OPEN,
} from './cartTypes';
import {
  DELIVERY,
  DROPOFF,
  PICKUP,
  RESET_ORDER_SETTING_TIME_SETTINGS,
} from '../OrderSetting/orderSettingTypes';
import api from '../../api';
import isValidCreditCard from '../../utils/isValidCreditCard';
import { createAlert } from '../Alert/alertActions';
import flattenProduct from '../../utils/flattenProduct';
import calculatePrice from '../../utils/calculatePrice';
import { getPaymentMethods } from '../PaymentMethods/paymentMethodsActions';
import identifyCartChanges from '../OrderSetting/utils/identifyCartChanges';
import { setIsGuestCheckoutInitialized } from '../Auth/authActions';
import { useDispatch } from 'react-redux';
// import identifyCartChanges from '../OrderSetting/utils/identifyCartChanges';
import {
  formatSelectedDateTime,
  setInterDeliveryDetailsId,
} from '../OrderSetting/orderSettingActions';
import productForCartValidation from './utils/productForCartValidation';
import comboForCartValidation from './utils/comboForCartValidation';
import moment from 'moment';
import appConfigFile from '../../../app-config';
import { isValid } from 'date-fns';
import { guestInfoClients } from '../../clientCustomizations';
import appConfig from '../../../app-config';

const PATTERN_PAYLOAD = '$$PAYLOAD$$';

export function updateShouldNavigateToCart(shouldNavigateToCart) {
  return {
    type: 'UPDATE_SHOULD_NAVIGATE_TO_CART',
    shouldNavigateToCart,
  };
}

export function addToCart(product, notFavourite) {
  return {
    type: ADD_TO_CART,
    product: notFavourite
      ? { ...product, isFromFavourite: false, favouriteId: null }
      : product,
  };
}

export const addComboToCart = (comboData) => {
  return {
    type: ADD_COMBO_TO_CART,
    comboData,
  };
};

export function initializeValidateCartWithNull() {
  return {
    type: INITIALIZE_VALIDATE_CART_WITH_NULL,
  };
}

export function removeProductFromCart(productIndexInCart) {
  return {
    type: REMOVE_PRODUCT_FROM_CART,
    productIndexInCart,
  };
}

export const setScreenToShow = (screenToShow) => {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_GUEST_SCREEN_SHOW',
      screenToShow,
    });
  };
};
export const removeComboFromCart = (comboIndexInCart) => {
  return (dispatch) => {
    dispatch({
      type: REMOVE_COMBO_FROM_CART,
      comboIndexInCart,
    });
  };
};

export function incrementProduct(productIndexInCart) {
  return {
    type: INCREMENT_PRODUCT,
    productIndexInCart,
  };
}

export function decrementProduct(productIndexInCart) {
  return {
    type: DECREMENT_PRODUCT,
    productIndexInCart,
  };
}

export function emptyCart() {
  return function(dispatch) {
    dispatch({ type: EMPTY_CART });
  };
}
// GLOBAL
export function clearErrorMessage() {
  return function(dispatch) {
    dispatch({ type: 'CLEAR_CART_ERROR_MESSAGE', errors: [] });
  };
}
export function updateGlobalCart(updatedCart) {
  return function(dispatch) {
    dispatch({ type: UPDATE_CART_REQUEST, updatedCart: updatedCart });
  };
}
// GLOBAL CART
export function validateGlobalCart(
  fromLocationsScreen = false,
  dontClearTheCart = false,
  businessId,
  goToCheckout = false,
  deliveryAddressId
) {
  return function(dispatch, getState) {
    const {
      cart,
      products,
      combos,
      cartScreen,
      guestPersonalDetails,
      specialInstructions,
    } = getState().cartReducer;
    const {
      isAuthenticated,
      appConfig,
      session_id,
      isGuestSessionInitiated,
    } = getState().authReducer;
    const { promoCodes } = getState().couponsReducer;
    const selectedDropOffLocation = getState().dropOffLocationReducer
      .selectedDropOffLocation;

    const {
      interPickUpDetails,
      interDeliveryDetails,
      interDropOffDetails,
      interOrderType,
      interSelectedDateTime,
      dateTimeToShow,
    } = getState().orderSettingReducer;
    const guestDeliveryFormInitialAddress = getState().deliveryAddressesReducer
      .guestDeliveryFormInitialAddress;
    if (
      !cart?.cart?.length > 0 ||
      (!appConfig.guest_checkout_enabled && !isAuthenticated) ||
      (!isAuthenticated &&
        cartScreen === 'guest-order' &&
        !isGuestSessionInitiated) ||
      (!isAuthenticated &&
        cartScreen === 'review' &&
        !isGuestSessionInitiated) ||
      (!isAuthenticated && cartScreen === 'menu' && !isGuestSessionInitiated)
    ) {
      return;
    }

    const tipPercentage = parseFloat(cart.tip);

    const location =
      interOrderType === PICKUP
        ? interPickUpDetails
        : interOrderType === DELIVERY
        ? interDeliveryDetails
        : interOrderType === DROPOFF
        ? interDropOffDetails
        : null;

    let order_date;
    if (dateTimeToShow && dateTimeToShow.value !== 'asap') {
      order_date = moment(
        dateTimeToShow.value,
        'ddd, MMM Do YYYY, h:mm A'
      ).format('YYYY-MM-DD HH:mm:ss');
    }

    // let isValidChoice =
    //   location && interOrderType !== DELIVERY && location.settings
    //     ? (interSelectedDateTime.radioValue.value === 'asap' &&
    //         location.settings.is_asap_order_enabled) ||
    //       (interSelectedDateTime.radioValue.value === 'schedule' &&
    //         location.settings.is_future_order_enabled)
    //     : location && interOrderType === DELIVERY && location.deliveryBusiness
    //     ? (interSelectedDateTime.radioValue.value === 'asap' &&
    //         location.deliveryBusiness.settings.is_asap_order_enabled) ||
    //       (interSelectedDateTime.radioValue.value === 'schedule' &&
    //         location.deliveryBusiness.settings.is_future_order_enabled)
    //     : false;

    let isValidChoice = false;

    if (interOrderType !== DELIVERY && location?.settings) {
      isValidChoice =
        (interSelectedDateTime.radioValue.value === 'asap' &&
          location.settings.is_asap_order_enabled) ||
        (interSelectedDateTime.radioValue.value === 'schedule' &&
          location.settings.is_future_order_enabled);
    } else if (interOrderType === DELIVERY && location?.deliveryBusiness) {
      isValidChoice =
        (interSelectedDateTime.radioValue.value === 'asap' &&
          location.deliveryBusiness.settings.is_asap_order_enabled) ||
        (interSelectedDateTime.radioValue.value === 'schedule' &&
          location.deliveryBusiness.settings.is_future_order_enabled);
    } else {
      isValidChoice = false;
    }

    if (location && isValidChoice) {
      dispatch({ type: VALIDATE_CART_REQUEST });
      const endpoint =
        !isAuthenticated && appConfig.guest_checkout_enabled
          ? '/guest/cart/validate'
          : '/cart/validate';

      let payload = {
        business_id: businessId
          ? businessId
          : interOrderType === DELIVERY && location.deliveryBusiness
          ? location.deliveryBusiness.id
          : location.id,

        tip: tipPercentage || 0,
        cart: [
          ...products.map((product) =>
            productForCartValidation(product.flatProduct)
          ),
          ...comboForCartValidation(combos || []),
        ],
        order_type: interOrderType,
        promo_codes: promoCodes,
      };

      if (order_date)
        payload = {
          ...payload,
          order_date,
        };

      if (
        interOrderType === DELIVERY &&
        !isAuthenticated &&
        location &&
        appConfig.guest_checkout_enabled
      ) {
        const {
          city,
          line1,
          line2,
          state,
          country,
          zip,
          type,
          is_preferred,
          details,
        } = guestDeliveryFormInitialAddress;
        payload = {
          ...payload,
          delivery_address: {
            line1,
            line2,
            city,
            state,
            zip,
            country,
            type,
            is_preferred,
            details,
          },
        };
      } else if (interOrderType === DELIVERY && isAuthenticated && location) {
        payload = {
          ...payload,
          customer_address_id: deliveryAddressId || location.id,
        };
      } else if (
        interOrderType === DROPOFF &&
        (isAuthenticated ||
          (!isAuthenticated && appConfig.guest_checkout_enabled)) &&
        location
      ) {
        let dropOffLocation = [...selectedDropOffLocation];
        const dropOffLocationObject = dropOffLocation
          .reverse()
          .reduce((obj, selection) => {
            return {
              id: selection.id,
              option: { ...obj },
            };
          }, {});

        payload = {
          ...payload,
          drop_off_location: dropOffLocationObject,
        };
      }
      if (payload?.cart?.length === 0) {
        return;
      }
      if (
        fromLocationsScreen ||
        (isAuthenticated &&
          (cartScreen === 'review' ||
            cartScreen === 'checkout' ||
            cartScreen === 'customer-info' ||
            cartScreen === 'menu')) ||
        (!isAuthenticated &&
          appConfig &&
          appConfig.guest_checkout_enabled &&
          guestPersonalDetails.email !== '' &&
          cartScreen === 'review') ||
        cartScreen === 'checkout' ||
        cartScreen === 'customer-info' ||
        cartScreen === 'guest-order' ||
        cartScreen === 'menu'
      ) {
        return api
          .post(endpoint, payload, { ignore_interception: true })
          .then((response) => {
            let validatedFlatProducts = [];
            response.data.data.products.map((product) => {
              let flatProduct = flattenProduct({
                ...product,
                options: product.options || [],
              });
              flatProduct.name = product.name;
              const price = calculatePrice(flatProduct);

              validatedFlatProducts.push({ ...flatProduct, ...price });
            });
            let validatedCart = { ...response.data.data };
            if (validatedCart.combos?.length > 0) {
              validatedCart.combos = validatedCart.combos.map(
                (combo, index) => {
                  return { ...combo, totalPrice: combos[index].totalPrice };
                }
              );
            }
            dispatch({
              type: VALIDATE_CART_SUCCESS,
              tipPercentage: tipPercentage,
              response: {
                ...validatedCart,
                validatedFlatProducts: validatedFlatProducts,
              },
              requestedCart: cart,
            });
            dispatch({
              type: 'UPDATE_CART_ERROR_MESSAGE',
              cartErrorMessage: [],
              errors: {},
            });

            if (cartScreen === 'review' && goToCheckout) {
              if (isAuthenticated) {
                dispatch({
                  type: UPDATE_CART_SCREEN,
                  cartScreen: 'checkout',
                });
              } else if (guestInfoClients.includes(appConfigFile.appSource)) {
                dispatch({
                  type: UPDATE_CART_SCREEN,
                  cartScreen: 'guest-order',
                });
                dispatch(setScreenToShow('payment-details'));
              }
            }
          })
          .catch((error) => {
            dispatch({
              type: 'UPDATE_CART_ERROR_MESSAGE',
              errors: error.response.data.errors,
            });
            if (
              error.response.status === 400 &&
              error.response.data.errors.message === 'Invalid cart'
            ) {
              const newCart =
                error.response.data?.errors?.details?.new_cart?.cart || [];

              const products = getState().cartReducer.products;
              const combos = getState().cartReducer.combos;
              const unavailableProducts = identifyCartChanges(
                newCart,
                products,
                combos
              );
              if (
                !appConfigFile.parentChildClient &&
                !dontClearTheCart &&
                cartScreen !== 'guest-order'
              ) {
                dispatch(updateCartWithUnavailbleProducts(unavailableProducts));
                dispatch(
                  updateCartWithUnavailbleProducts(
                    unavailableProducts.map((item) => item.product_id)
                  )
                );
              }
              dispatch({
                type: 'UPDATE_UNAVAILABLE_PRODUCTS',
                unavailableProducts,
              });

              if (cartScreen === 'checkout')
                dispatch({
                  type: UPDATE_CART_SCREEN,
                  cartScreen: 'review',
                });
            } else {
              const products = getState().cartReducer.products;
              const combos = getState().cartReducer.combos;
              const unavailableProducts = identifyCartChanges(
                null,
                products,
                combos
              );
              dispatch({
                type: 'UPDATE_UNAVAILABLE_PRODUCTS',
                unavailableProducts,
              });
            }
          });
      }
    }
  };
}

export function getUpsellCombos(shouldCallOffers) {
  return function(dispatch, getState) {
    const {
      cart,
      products,
      combos,
      cartScreen,
      specialInstructions,
    } = getState().cartReducer;
    const {
      interPickUpDetails,
      interDeliveryDetails,
      interDropOffDetails,
      interOrderType,
      interSelectedDateTime,
      dateTimeToShow,
    } = getState().orderSettingReducer;

    const location =
      interOrderType === PICKUP
        ? interPickUpDetails
        : interOrderType === DELIVERY
        ? interDeliveryDetails
        : interOrderType === DROPOFF
        ? interDropOffDetails
        : null;

    const tipPercentage = parseFloat(cart.tip);
    const { isAuthenticated, appConfig } = getState().authReducer;
    const selectedDropOffLocation = getState().dropOffLocationReducer
      .selectedDropOffLocation;

    if (location) {
      dispatch({ type: VALIDATE_CART_REQUEST });
      const endpoint = '/cart/validate';
      let payload = {
        business_id:
          interOrderType !== DELIVERY
            ? location.id
            : location.deliveryBusiness.id,
        tip: tipPercentage || 0,
        cart: [
          ...products.map((product) =>
            productForCartValidation(product.flatProduct)
          ),
          ...comboForCartValidation(combos || []),
        ],
        order_type: interOrderType,
      };

      if (interOrderType === DELIVERY && isAuthenticated) {
        if (location.id) {
          payload = {
            ...payload,
            customer_address_id: location.id,
          };
        } else return;
      } else if (interOrderType === DROPOFF && isAuthenticated) {
        let dropOffLocation = [...selectedDropOffLocation];
        const dropOffLocationObject = dropOffLocation
          .reverse()
          .reduce((obj, selection) => {
            return {
              id: selection.id,
              option: { ...obj },
            };
          }, {});

        payload = {
          ...payload,
          drop_off_location: dropOffLocationObject,
        };
      }

      let itemsToRemove = [];
      if (isAuthenticated && payload.cart.length > 0) {
        let order_date;
        if (dateTimeToShow && dateTimeToShow.value !== 'asap') {
          order_date = moment(
            dateTimeToShow.value,
            'ddd, MMM Do YYYY, h:mm A'
          ).format('YYYY-MM-DD HH:mm:ss');
        }
        if (order_date) {
          payload = {
            ...payload,
            order_date,
          };
        }
        return api
          .post(endpoint, payload, { ignore_interception: true })
          .then((response) => {
            let combos = [];
            response.data.data.upsell.forEach((combo) => {
              if (combo.combos && combo.combos.length) {
                combo.combos.forEach((combo) => {
                  if (products && products.length > 0) {
                    let upsellComboProduct = getProductsInfoFromUpsellCombo(
                      combo
                    );

                    //prefills the combo with related product on cart
                    products.forEach((product) => {
                      upsellComboProduct.product_by_group
                        .filter(
                          (comboInfo) =>
                            comboInfo.productId ===
                            product.flatProduct.product_id
                        )
                        .forEach((comboInfo) => {
                          if (combo.id === comboInfo.combo_id) {
                            combo.group_index = comboInfo.group_index;
                            combo.combo_item_groups[comboInfo.group_index][
                              'productCustomizer'
                            ] = product;
                          }
                        });

                      if (
                        upsellComboProduct.allProductsIds.includes(
                          product.flatProduct.product_id
                        )
                      ) {
                        const itemExistOnList = itemsToRemove.filter(
                          (item) =>
                            item.productId === product.flatProduct.product_id
                        );

                        const itemIndex = itemsToRemove
                          .map((item) => item.productId)
                          .indexOf(product.flatProduct.product_id);

                        if (itemExistOnList.length > 0 && itemIndex >= 0) {
                          if (
                            !itemsToRemove[itemIndex].comboId.includes(combo.id)
                          ) {
                            itemsToRemove[itemIndex].comboId.push(combo.id);
                          }
                        } else {
                          itemsToRemove.push({
                            comboId: [combo.id],
                            productId: product.flatProduct.product_id,
                          });
                        }
                      }
                    });
                  }
                  combos.push(combo);
                });
              }
            });

            dispatch({
              type: SET_UPSELL_COMBOS,
              upsellCombos: combos,
            });

            if (itemsToRemove.length)
              dispatch({
                type: SET_PRODUCTS_TO_REPLACE_WITH_COMBO,
                itemsToReplace: itemsToRemove,
              });
          })
          .catch((error) => {
            dispatch({
              type: 'UPDATE_CART_ERROR_MESSAGE',
              errors: error.response?.data.errors,
            });
            dispatch({
              type: SET_PRODUCTS_TO_REPLACE_WITH_COMBO,
              itemsToReplace: [],
            });
          });
      }
      //FILL CART ERROR MESSAGE AND PROCEED
    }
  };
}

const getProductsInfoFromUpsellCombo = (combo) => {
  let products_information = {
    allProductsIds: [],
    product_by_group: [],
  };

  combo.combo_item_groups.forEach((group, index) => {
    group.combo_items.forEach((item) => {
      products_information.product_by_group.push({
        group_id: group.combo_item_group_id,
        group_index: index,
        combo_id: combo.id,
        productId: item.product_id,
        is_upsell_combo: true,
      });

      products_information.allProductsIds.push(item.product_id);
    });
  });

  return products_information;
};

export function resetUpsellCombos() {
  return function(dispatch) {
    dispatch({
      type: SET_UPSELL_COMBOS,
      upsellCombos: [],
    });
  };
}

export function updateUnavailableProducts(products) {
  return function(dispatch) {
    dispatch({
      type: 'UPDATE_UNAVAILABLE_PRODUCTS',
      unavailableProducts: products,
    });
  };
}

export function validateCartForLocation(location) {
  return function(dispatch, getState) {
    const {
      cart,
      products,
      combos,
      cartScreen,
      specialInstructions,
    } = getState().cartReducer;
    const tipPercentage = parseFloat(cart.tip);
    const { isAuthenticated, appConfig } = getState().authReducer;
    const selectedDropOffLocation = getState().dropOffLocationReducer
      .selectedDropOffLocation;
    const { interOrderType, dateTimeToShow } = getState().orderSettingReducer;

    if (location) {
      dispatch({ type: VALIDATE_CART_REQUEST });
      const endpoint = '/cart/validate';
      let payload = {
        business_id:
          interOrderType !== DELIVERY
            ? location.id
            : location.deliveryBusiness.id,
        tip: tipPercentage || 0,
        cart: [
          ...products.map((product) =>
            productForCartValidation(product.flatProduct)
          ),
          ...comboForCartValidation(combos || []),
        ],
        order_type: interOrderType,
      };

      if (interOrderType === DELIVERY && isAuthenticated) {
        if (location.id) {
          payload = {
            ...payload,
            customer_address_id: location.id,
          };
        } else return;
      } else if (interOrderType === DROPOFF && isAuthenticated) {
        let dropOffLocation = [...selectedDropOffLocation];
        const dropOffLocationObject = dropOffLocation
          .reverse()
          .reduce((obj, selection) => {
            return {
              id: selection.id,
              option: { ...obj },
            };
          }, {});

        payload = {
          ...payload,
          drop_off_location: dropOffLocationObject,
        };
      }

      if (isAuthenticated && payload.cart.length > 0) {
        //FILL CART ERROR MESSAGE AND PROCEED
        let order_date;
        if (dateTimeToShow && dateTimeToShow.value !== 'asap') {
          order_date = moment(
            dateTimeToShow.value,
            'ddd, MMM Do YYYY, h:mm A'
          ).format('YYYY-MM-DD HH:mm:ss');
        }
        if (order_date) {
          payload = {
            ...payload,
            order_date,
          };
        }
        return api
          .post(endpoint, payload, { ignore_interception: true })
          .then((response) => {
            let validatedFlatProducts = [];
            response.data.data.products.map((product) => {
              let flatProduct = flattenProduct({
                ...product,
                options: product.options || [],
              });
              flatProduct.name = product.name;
              const price = calculatePrice(flatProduct);

              validatedFlatProducts.push({ ...flatProduct, ...price });
            });
            dispatch({
              type: VALIDATE_CART_SUCCESS,
              tipPercentage: tipPercentage,
              response: {
                ...response.data.data,
                validatedFlatProducts: validatedFlatProducts,
              },
              requestedCart: cart,
            });
            dispatch({
              type: 'UPDATE_CART_ERROR_MESSAGE',
              cartErrorMessage: [],
              errors: {},
            });
          })
          .catch((error) => {
            if (error.response.data.errors.details)
              dispatch({
                type: 'UPDATE_CART_ERROR_MESSAGE',
                errors: error.response.data.errors.details.cart_changes,
              });

            if (
              error.response.status === 400 &&
              error.response.data.errors.message === 'Invalid cart'
            ) {
              const newCart =
                error.response.data?.errors?.details?.new_cart?.cart || [];

              const products = getState().cartReducer.products;
              const combos = getState().cartReducer.combos;
              const unavailableProducts = identifyCartChanges(
                newCart,
                products,
                combos
              );

              dispatch({
                type: 'UPDATE_UNAVAILABLE_PRODUCTS',
                unavailableProducts,
              });

              if (!appConfigFile.parentChildClient) {
                dispatch(updateCartWithUnavailbleProducts(unavailableProducts));
                dispatch(
                  updateCartWithUnavailbleProducts(
                    unavailableProducts.map((item) => item.product_id)
                  )
                );
              }
            } else {
              const products = getState().cartReducer.products;
              const combos = getState().cartReducer.combos;
              const unavailableProducts = identifyCartChanges(
                null,
                products,
                combos
              );
              dispatch({
                type: 'UPDATE_UNAVAILABLE_PRODUCTS',
                unavailableProducts,
              });
            }
          });
      }
    }
  };
}

export function validateGuestCart(cart) {
  return function(dispatch, getState) {
    const { tipPercentage } = getState().cartReducer;
    dispatch({
      type: 'UPDATE_CART_ERROR_MESSAGE',
      cartErrorMessage: [],
    });
    dispatch({ type: VALIDATE_GUEST_CART_REQUEST });
    return api
      .post('/guest/cart/validate', { ...cart })
      .then((response) => {
        let validatedFlatProducts = [];
        response.data.data.products.map((product) => {
          let flatProduct = flattenProduct({
            ...product,
            options: product.options || [],
          });

          flatProduct.name = product.name;
          const price = calculatePrice(flatProduct);

          validatedFlatProducts.push({ ...flatProduct, ...price });
        });
        dispatch({
          type: 'UPDATE_CART_ERROR_MESSAGE',
          cartErrorMessage: [],
        });
        dispatch({
          type: VALIDATE_GUEST_CART_SUCCESS,
          tipPercentage: tipPercentage,
          response: {
            ...response.data.data,
            validatedFlatProducts: validatedFlatProducts,
          },
          requestedCart: cart,
        });
      })
      .catch((error) => {
        dispatch({
          type: 'UPDATE_CART_ERROR_MESSAGE',
          errors: error.response.data.errors,
        });
      });
  };
}

export const changeTipPercentage = (tip) => (dispatch) => {
  return function(dispatch) {
    dispatch({
      type: CHANGE_TIP_PERCENTAGE,
      tipPercentage: tip,
    });
  };
};

export function resetTipPercentage() {
  return {
    type: RESET_TIP_PERCENTAGE,
  };
}

export function changeSpecialInstructions(specialInstructions) {
  return {
    type: CHANGE_SPECIAL_INSTRUCTIONS,
    specialInstructions,
  };
}

export function placeOrder(orderConfig, isGoogleOrApplePay = false) {
  return function(dispatch, getState) {
    orderConfig = {
      ...orderConfig,
      tip: getState().cartReducer.tipPercentage,
      promo_codes: getState().couponsReducer.promoCodes,
    };
    const coords = getState().locationsReducer.currentLocation;
    const selectedPaymentMethod = getState().paymentMethodsReducer
      .selectedPaymentMethod;

    if (coords) {
      orderConfig = {
        ...orderConfig,
        latitude: coords.latitude,
        longitude: coords.longitude,
      };
    } else {
      orderConfig = {
        ...orderConfig,
        latitude: 0,
        longitude: 0,
      };
    }
    const creditCard = getState().paymentMethodsReducer?.paymentMethods?.find(
      (card) => card.is_preferred
    );

    if (
      selectedPaymentMethod !== 'poa' &&
      creditCard &&
      creditCard.type === 'credit_card' &&
      creditCard.details.expiry_date.slice(5, 7) > 12
    ) {
      dispatch({
        type: 'UPDATE_CART_ERROR_MESSAGE',
        errors: {
          details: null,
          message: 'Invalid Expiry Date',
        },
      });
      // return dispatch(
      //   createAlert({ type: 'error', message: 'Invalid Expiry Date' })
      // );
    }
    if (
      selectedPaymentMethod !== 'poa' &&
      creditCard &&
      creditCard.type === 'credit_card' &&
      !isValidCreditCard(
        creditCard.details.expiry_date.slice(5, 7),
        creditCard.details.expiry_date.slice(0, 4)
      )
    ) {
      dispatch({
        type: 'UPDATE_CART_ERROR_MESSAGE',
        errors: {
          details: null,
          message: 'Expired Credit Card',
        },
      });
      // return dispatch(
      //   createAlert({ type: 'error', message: 'Expired Credit Card' })
      // );
    }
    dispatch({ type: PLACE_ORDER_REQUEST });
    return api.post('/payment-code').then((response) => {
      // get address
      const customer_address_id =
        getState().orderSettingReducer.orderType === DELIVERY
          ? getState().orderSettingReducer.interDeliveryDetails.id
          : null;

      // get dropoff location
      const dropOffLocation =
        getState().orderSettingReducer.orderType === DROPOFF
          ? getState().orderSettingReducer.interDropOffDetails.id
          : null;
      // make base body
      let qr_code = response.data.data.pattern;
      qr_code = qr_code.replace(
        PATTERN_PAYLOAD,
        response.data.data.payment_code
      );

      let body = null;

      if (selectedPaymentMethod === 'poa' && !isGoogleOrApplePay) {
        body = {
          ...orderConfig,
          is_loyalty: true,
        };
      } else {
        body = {
          ...orderConfig,
          qr_code,
        };
      }

      // if delivery address, add it
      if (guestInfoClients.includes(appConfigFile.appSource)) {
        const customerInfo = JSON.parse(sessionStorage.getItem('customerInfo'));
        let orderInstruction = `${orderConfig.specialInstructions ||
          ''}\nGuest Name on the Reservation: ${
          customerInfo.guest_name
        }\nArrival Date: ${customerInfo.arrival_date}\nConfirmation #: ${
          customerInfo.confirmation_number
        }\nGuest Message: ${customerInfo.note}`;
        body = {
          ...body,
          special_instruction: orderInstruction,
        };
      }
      if (customer_address_id) {
        body = {
          ...body,
          customer_address_id,
        };
      }
      const hasUtensils = sessionStorage.getItem('utensils');
      if (hasUtensils) {
        body = {
          ...body,
          special_instruction: `Add Cutlery\n${body.special_instruction}`,
        };
      }
      console.log('body', body);
      api
        .post('/orders', body, { ignore_interception: true })
        .then((response) => {
          sessionStorage.removeItem('utensils');
          sessionStorage.removeItem('customerInfo');
          let placedOrder = {
            ...response.data.data,
          };
          if (customer_address_id) {
            let deliveryAddress = getState().deliveryAddressesReducer.deliveryAddressesList.find(
              (deliveryAddress) => deliveryAddress.id === customer_address_id
            );
            placedOrder = {
              ...placedOrder,
              orderType: DELIVERY,
              address: deliveryAddress,
            };
          } else if (dropOffLocation) {
            let dropOffLocation = getState().dropOffLocationReducer
              .selectedDropOffLocation;
            placedOrder = {
              ...placedOrder,
              orderType: DROPOFF,
              address: [...dropOffLocation],
            };
          } else {
            let businessAddress = getState().locationsReducer.locations.find(
              (location) => location.id === orderConfig.business_id
            );
            placedOrder = {
              ...placedOrder,
              orderType: PICKUP,
              address: businessAddress,
            };
          }
          dispatch({
            type: PLACE_ORDER_SUCCESS,
            response: placedOrder,
          });
          dispatch({
            type: 'UPDATE_CART_ERROR_MESSAGE',
            errors: null,
          });
          dispatch(getPaymentMethods());
        })
        .catch((error) => {
          dispatch({
            type: PLACE_GUEST_ORDER_FAILURE,
          });
          dispatch({
            type: 'UPDATE_CART_ERROR_MESSAGE',
            errors: error.response.data.errors,
          });
        })
        .finally(() => {
          dispatch({
            type: 'UPDATE_GOOGLE_OR_APPLY_PAY_LOADER_STATUS',
            loading: false,
          });
        });
    });
  };
}

export function placeGuestOrder(orderConfig, paymentDetails, giftCard) {
  return function(dispatch, getState) {
    orderConfig = {
      ...orderConfig,
      tip: getState().cartReducer.tipPercentage,
    };
    const coords = getState().locationsReducer.currentLocation;

    if (coords) {
      orderConfig = {
        ...orderConfig,
        latitude: coords.latitude,
        longitude: coords.longitude,
      };
    } else {
      orderConfig = {
        ...orderConfig,
        latitude: 0,
        longitude: 0,
      };
    }

    const guestPaymentMethod = getState().paymentMethodsReducer
      .guestPaymentMethod;

    if (paymentDetails) {
      if (guestPaymentMethod === 'creditCard') {
        orderConfig = {
          ...orderConfig,
          is_loyalty: false,
          payment: {
            payment_method: 'credit_card',
            credit_card: {
              cardholder_name: paymentDetails.cardholder_name,
              card_number: paymentDetails.card_number,
              cvv: paymentDetails.cvv,
              expiry_date: `${paymentDetails.expiry_year}-${paymentDetails.expiry_month}-01`,
              postal_code: paymentDetails.postal_code,
              street_name: paymentDetails.street_name,
              street_number: paymentDetails.street_number,
            },
          },
        };
      } else if (guestPaymentMethod === 'giftCard') {
        const cardNumber = giftCard.gift_card_number
          .split(' ')
          .join('')
          .toString();
        orderConfig = {
          ...orderConfig,
          is_loyalty: false,
          payment: {
            payment_method: 'gift_card',
            gift_card: {
              card_number: cardNumber,
              pin: giftCard.pin,
            },
          },
        };
      } else {
        orderConfig = {
          ...orderConfig,
          is_loyalty: true,
        };
      }
    }

    if (
      guestPaymentMethod !== 'giftCard' &&
      guestPaymentMethod !== 'poa' &&
      paymentDetails.expiry_month > 12
    ) {
      dispatch({
        type: 'UPDATE_CART_ERROR_MESSAGE',
        errors: {
          details: null,
          message: 'Invalid Expiry Date',
        },
      });
      // return dispatch(
      //   createAlert({ type: 'error', message: 'Invalid Expiry Date' })
      // );
    }
    if (
      guestPaymentMethod !== 'giftCard' &&
      guestPaymentMethod !== 'poa' &&
      !isValidCreditCard(
        paymentDetails.expiry_month,
        paymentDetails.expiry_year
      )
    ) {
      dispatch({
        type: 'UPDATE_CART_ERROR_MESSAGE',
        errors: {
          details: null,
          message: 'Expired Credit Card',
        },
      });
    }

    if (guestInfoClients.includes(appConfigFile.appSource)) {
      const customerInfo = JSON.parse(sessionStorage.getItem('customerInfo'));
      const orderInstruction = `${orderConfig.specialInstructions ||
        ''}\nGuest Name on the Reservation: ${
        customerInfo.guest_name
      }\nArrival Date: ${customerInfo.arrival_date}\nConfirmation #: ${
        customerInfo.confirmation_number
      }\nGuest Message: ${customerInfo.note}`;
      orderConfig = {
        ...orderConfig,
        special_instruction: orderInstruction,
      };
    }
    dispatch({ type: PLACE_GUEST_ORDER_REQUEST });
    const hasUtensils = sessionStorage.getItem('utensils');
    if (hasUtensils) {
      orderConfig = {
        ...orderConfig,
        special_instruction: `Add Cutlery\n${orderConfig.special_instruction}`,
      };
    }
    api
      .post('/guest/orders', orderConfig, { ignore_interception: true })
      .then((response) => {
        sessionStorage.removeItem('utensils');
        sessionStorage.removeItem('customerInfo');
        let placedOrder = {
          ...response.data.data,
        };
        placedOrder = {
          ...placedOrder,
          orderType: getState().orderSettingReducer.orderType,
        };

        dispatch({
          type: PLACE_GUEST_ORDER_SUCCESS,
          response: placedOrder,
        });
        // dispatch({
        //   type: RESET_ORDER_SETTING_TIME_SETTINGS,
        //   dateTimeToShow: formatSelectedDateTime(),
        // });
        dispatch({
          type: 'UPDATE_CART_ERROR_MESSAGE',
          cartErrorMessage: [],
        });
      })
      .catch((error) => {
        dispatch({
          type: PLACE_GUEST_ORDER_FAILURE,
        });
        dispatch({
          type: 'UPDATE_CART_ERROR_MESSAGE',
          errors: error.response.data.errors,
        });
      })
      .finally(() => {
        dispatch({
          type: 'UPDATE_GOOGLE_OR_APPLY_PAY_LOADER_STATUS',
          loading: false,
        });
      });
  };
}

export function toggleProductIsFavourited(productIndexInCart, favouriteId) {
  return {
    type: TOGGLE_PRODUCT_IS_FAVOURITED,
    productIndexInCart,
    favouriteId,
  };
}

export function unfavouriteByFavouriteId(favouriteId) {
  return {
    type: UNFAVOURITE_BY_FAVOURITE_ID,
    favouriteId,
  };
}

export function invalidateCart() {
  return {
    type: INVALIDATE_CART,
  };
}

export function setIsForPreview(isForPreview) {
  return {
    type: SET_IS_FOR_PREVIEW,
    isForPreview,
  };
}

export function resetInvalidTip() {
  return function(dispatch) {
    dispatch({ type: RESET_INVALID_TIP_FLAG });
  };
}
export function updateCartWithFavouritedProducts(products) {
  return function(dispatch) {
    dispatch({ type: UPDATE_CART_PRODUCTS, products });
  };
}

export function updateCartWithUnavailbleProducts(unavaliableProductIds) {
  return function(dispatch, getState) {
    let products = getState().cartReducer.products;
    let combos = getState().cartReducer.combos;
    products = products.filter((product) => {
      return !unavaliableProductIds.includes(
        parseInt(product.flatProduct.product_id)
      );
    });
    combos = combos.filter((combo) => {
      return !unavaliableProductIds.includes(parseInt(combo.id));
    });

    dispatch({ type: UPDATE_CART_PRODUCTS, products, combos });
    dispatch({ type: 'UPDATE_CART_COMBOS', combosModified: combos });

    dispatch({
      type: 'UPDATE_UNAVAILABLE_PRODUCTS',
      unavailableProducts: null,
    });
    dispatch({
      type: 'UPDATE_CART_ERROR_MESSAGE',
      errors: {},
    });
  };
}

export function updateCartNewPrices(newCart) {
  return function(dispatch) {
    dispatch({ type: 'UPDATE_CART_NEW_PRICES', newCart });
  };
}

export function updateCartScreen(cartScreen) {
  return {
    type: UPDATE_CART_SCREEN,
    cartScreen,
  };
}

export function setCheckoutAsGuestButtonIsVisible(bool) {
  return function(dispatch) {
    dispatch({ type: SET_CHECKOUT_AS_GUEST_BUTTON_IS_VISIBLE, bool });
  };
}

export function setShowGuestPersonalDetailsPage(bool) {
  return function(dispatch) {
    dispatch({ type: SET_SHOW_GUEST_PERSONAL_DETAILS_PAGE, bool });
  };
}

export function setAccountFoundModalIsVisible(bool) {
  return function(dispatch) {
    dispatch({ type: SET_ACCOUNT_FOUND_MODAL_IS_VISIBLE, bool });
  };
}

export function setGuestPersonalDetails(personalDetails) {
  return function(dispatch) {
    dispatch({ type: SET_GUEST_PERSONAL_DETAILS, personalDetails });
  };
}

export function resetGuestPersonalDetails() {
  return function(dispatch) {
    dispatch({ type: RESET_GUEST_PERSONAL_DETAILS });
  };
}

export function resetCartErrorMessages() {
  return function(dispatch) {
    dispatch({
      type: 'UPDATE_CART_ERROR_MESSAGE',
      errors: null,
    });
  };
}

export function resetPlaceOrderRequest() {
  return function(dispatch) {
    dispatch({
      type: PLACE_GUEST_ORDER_FAILURE,
    });
  };
}

export function setIsReloadGiftCardOpen(bool) {
  return function(dispatch) {
    dispatch({ type: SET_RELOAD_GIFT_CARD_DIALOG_OPEN, bool });
  };
}
export function updateGoogleOrApplePayLoaderStatus(loading) {
  return function(dispatch) {
    dispatch({ type: 'UPDATE_GOOGLE_OR_APPLY_PAY_LOADER_STATUS', loading });
  };
}

export function getGoogleMerchantId() {
  return function(dispatch, getState) {
    const id = getState().orderSettingReducer?.selectedLocation?.id;
    const { payment_methods } = getState().authReducer?.appConfig;
    console.log('getGoogleMerchantId', id);
    if (!payment_methods?.includes('google_pay')) {
      return;
    }
    return api.get(`payment/config?type=google_pay&business_id=${id}`).then(
      (response) => {
        dispatch({
          type: 'GET_GOOGLE_MERCHANT_ID',
          googleMerchantId: response.data.data.merchant_id,
        });
      },
      (error) => {}
    );
  };
}
export function getAppleMerchantId() {
  return function(dispatch, getState) {
    const id = getState().orderSettingReducer?.selectedLocation?.id;
    const { payment_methods } = getState().authReducer?.appConfig;
    console.log('getAppleMerchantId', id);
    console.log('payment_methods', payment_methods);
    if (!payment_methods?.includes('apple_pay')) {
      return;
    }
    return api.get(`payment/config?type=apple_pay&business_id=${id}`).then(
      (response) => {
        console.log('getAppleMerchantId response', response.data.data);
        dispatch({
          type: 'GET_APPLE_MERCHANT_ID',
          appleStoreId: response.data.data.store_id,
        });
      },
      (error) => {}
    );
  };
}
export function getPaymentSession(business_id, amount) {
  const body = JSON.stringify({
    amount: amount,
    business_id: business_id,
  });
  return api.post('/payment/session', body, {
    headers: {
      'X-SP-API-Token': localStorage.getItem(`${appConfig.appSource}_token`),
    },
  });
}

export function updateGiftCardReloadAmount(giftCardReloadAmount) {
  return function(dispatch) {
    dispatch({
      type: 'UPDATE_GIFT_CARD_RELOAD_AMOUNT',
      giftCardReloadAmount,
    });
  };
}
